import Wrapper from 'components/wrapper';
import { fetchData } from 'lib/fetchData';
import type { GetStaticProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import * as React from 'react';
import { API } from '_helpers';

const Header = dynamic(import('components/header'));
const ContactUsCard = dynamic(
  import('components/contactUs/components/contactUsCards')
);
const ContactUsForm = dynamic(
  import('components/contactUs/components/contactUsForm')
);

interface IProps {
  menu: any;
  company: any;
  footer: any;
  header: any;
  contactUS: any;
  seo: any;
  locale: any;
}

const ContactUs: NextPage<IProps> = (props) => {
  const { menu, company, footer, header, contactUS, seo, locale } = props;

  const { asPath } = useRouter();
  return (
    <Wrapper menu={menu} company={company} footer={footer}>
      <Head>
        <title>{seo.pages[8].title}</title>
        <meta name="description" content={seo.pages[8].description} />
        <link rel="icon" href={API + company.favicon.media.url} />
        <meta name="robots" content="index,follow" />
        <meta
          property="article:published_time"
          content={new Date().toLocaleTimeString()}
        />
        <meta
          name="publish_date"
          property="og:publish_date"
          content={new Date().toLocaleDateString()}
        />
        <meta
          name="author"
          property="article:author"
          content="Luccin Masirika"
        />
        {/* Open Graph */}
        <meta property="og:title" content={seo.pages[8].title} />
        <meta property="og:description" content={seo.pages[8].description} />
        <meta
          property="og:url"
          content={`https://uptodatedevelopers.com${asPath}`}
        />
        <meta property="og:image" content={API + seo.pages[8].media.url} />
        <meta property="og:site_name" content={company.name} />
        <meta property="og:locale" content={locale} />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content={company.name} />
      </Head>
      <Header data={header.contactUs} />
      <ContactUsCard data={company} cards={contactUS.cards} />
      <ContactUsForm data={contactUS} />
    </Wrapper>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const header = await fetchData(`/headers/?_locale=${locale}`);
  const menu = await fetchData(`/menu/?_locale=${locale}`);
  const company = await fetchData(`/company/?_locale=${locale}`);
  const footer = await fetchData(`/footer/?_locale=${locale}`);
  const contactUS = await fetchData(`/contact-us/?_locale=${locale}`);
  const seo = await fetchData(`/seo/?_locale=${locale}`);

  return {
    props: {
      menu,
      company,
      footer,
      header,
      contactUS,
      seo,
      locale,
    },
    revalidate: 10,
  };
};

export default ContactUs;
